import API from '../../api/api';

const fetchData = async () => {
  try {
    const response = await API.API.get('profile/get-my-accounts');
    console.log(response.data); // Log the response data to the console
    // Check if the response status is false
    if (response.data.status === false) {
      // Handle the false response status
    }
    return response.data; // Return the fetched data
  } catch (error) {
    console.error('Error viewing account:', error);
    throw error; // Rethrow the error to be handled in the component
  }
};

export default fetchData;
